// Management.jsx
import React from 'react';
import classNames from 'classnames';

const ManagementTab = ({ PEAP_CONTENT, selectedContentType, setSelectedContentType }) => (
  <div className="w-full border-b-2 border-gray-200 dark:border-shoorah-darkBorder lg:mt-8">
    <nav className="-mb-px flex space-x-8 overflow-x-auto" aria-label="Tabs">
      {PEAP_CONTENT.map((tab) => (
        <div
          key={tab.name}
          onClick={() => {
            setSelectedContentType(tab.value);
          }}
          className={classNames(
            selectedContentType === tab.value
              ? 'border-shoorah-secondary text-shoorah-lightBlack dark:text-white'
              : 'border-transparent text-gray-500 opacity-50 dark:text-white hover:cursor-pointer hover:border-gray-100 hover:text-gray-700 dark:hover:border-shoorah-darkBorder',
            'whitespace-nowrap border-b-2 px-2 py-2 text-sm font-medium'
          )}
        >
          {tab.name}
        </div>
      ))}
    </nav>
  </div>
);

export default ManagementTab;
